"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NULL_ACTION = { type: null };

exports.default = NULL_ACTION;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/constants/null-action.js
// module id = 129
// module chunks = 0